/*
 * @Description:
 * @version:
 * @Author: knight
 * @Date: 2022-01-17 14:51:14
 * @LastEditors: knight
 * @LastEditTime: 2022-02-09 15:49:36
 */
const Vue = require('vue');
const VueRouter = require('vue-router');

Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    redirect: '',
    component: () => import('@/pages/layout'),
    children: [
      {
        path: '/',
        name: 'home',
        meta: {
          title: '首页',
        },
        component: () => import('@/pages/home'),
      },
      {
        path: '/activity/index',
        name: 'activity-list',
        meta: {
          title: '活动广场',
        },
        component: () => import('@/pages/activity/index'),
      },
      {
        path: '/anchor/index',
        name: 'anchor-list',
        meta: {
          title: '主播广场',
        },
        component: () => import('@/pages/anchor/index'),
      },
      {
        path: '/mine',
        name: 'mine',
        meta: {
          title: '我的',
        },
        component: () => import('@/pages/mine'),
      },
    ],
  },
  {
    path: '/activity/detail/:id',
    name: 'activity-detail',
    meta: {
      title: '活动详情',
    },
    component: () => import('@/pages/activity/detail'),
  },
  {
    path: '/activity/enroll',
    name: 'activity-enroll',
    meta: {
      title: '活动报名',
    },
    component: () => import('@/pages/activity/enroll'),
  },
  {
    path: '/anchor/detail/:id',
    name: 'activity-detail',
    meta: {
      title: '主播详情',
    },
    component: () => import('@/pages/anchor/detail'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
    },
    component: () => import('@/pages/login'),
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '注册',
    },
    component: () => import('@/pages/register'),
  },
  {
    path: '/forget',
    name: 'forget',
    meta: {
      title: '注册',
    },
    component: () => import('@/pages/forget'),
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/',
});

export default router;
